import React from "react";
import {
  Button,
  Group,
  Text,
  ThemeIcon,
  Container,
  Paper,
} from "@mantine/core";
import { IconGhost, IconArrowLeft } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";
import "./styles.scss";
import { Colors } from "../../Lib/data";

const Error404: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="error404-container">
      <div className="error404-bg" />
      <Container size={420} className="error404-content">
        <Group justify="center" mb={24}>
          <ThemeIcon size={80} radius={80} className="error404-icon">
            <IconGhost color={Colors.PurplePrimary} size={56} stroke={1.5} />
          </ThemeIcon>
        </Group>
        <Text fw={900} fz={80} ta="center" mb={8}>
          404
        </Text>
        <Text fw={700} fz={28} ta="center" mb={8}>
          Lost in the void?
        </Text>
        <Text c="dimmed" fz={18} ta="center" mb={32}>
          Sorry, the page you are looking for doesn’t exist or has been moved.
          <br />
          But don’t worry, you can always find your way back!
        </Text>
        <Group justify="center">
          <Link to="/d">
            <Button
              size="md"
              radius="xl"
              leftSection={<IconArrowLeft size={18} />}
              className="error404-btn"
            >
              Go Home
            </Button>
          </Link>
        </Group>
      </Container>
    </div>
  );
};

export default Error404;
